import { createReducer, createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  setPdfData: ['text']
});

export const PdfViewTypes = Types;
export default Creators;

/* ------- Initial State --------- */
export const INITIAL_STATE = {
  text: ''
};

/* ------- Selectors --------- */
export const PdfViewSelectors = {
  selectPdfText: state => state.pdfView.text
};

/* -------- Reducers ---------- */

export const setPdfData = (state, { text }) => {
  return {
    ...state,
    text
  };
};

/* -------- Hookup Reducers to Types -------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_PDF_DATA]: setPdfData
});
